import { PaginationResponse } from '../responses/PaginationResponse';
import { PageRequest } from '../requests/PageRequest';
import { HttpHeader } from '../utils/HttpHeader';
import { HttpRequester } from '../utils/HttpRequester';
import { Urls } from "../utils/Urls";
import { TokenService } from './TokenService';
import { Instrument, InstrumentCondition, UpvestAccount, UpvestAccountStatus, UpvestSavingPlan, UpvestValuationItem } from '../models';
import { ActivateUpvestAccountRequest, UpvestHistoryValueRequest } from '../requests';
import { formatDate } from '../Formatters';
import moment from 'moment';
import { PricePeriods } from '../contants';
import { UpvestPosition } from '../models';
export class TradingService {
    private static account:UpvestAccount;
    private static links = Urls.URLS();
    private static requester = HttpRequester.httpRequester();
    private static headers = new HttpHeader();
    public static setAccount(account:UpvestAccount){
        this.account = account;
    }
    public static async onBoardUser(request:ActivateUpvestAccountRequest):Promise<any>{
        try {
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.post(this.links.onBoardUser(), this.headers,request);
            return json.data;
        }
        catch (err) {
            throw err;
        }
    }
    public static async getUpvestAccountStatus(upvestUserId:number):Promise<Array<UpvestAccountStatus>>{
        try{
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.get(this.links.upvestAccountStatus(upvestUserId),this.headers);
            return json.data;
        }
        catch(err){
            throw err;
        }
    }
    public static async getUpvestAccount():Promise<UpvestAccount>{
        if(this.account){
            return this.account;
        }
        else{
            return this.loadUpvestAccount();
        }
        
    }
    public static async loadUpvestAccount():Promise<UpvestAccount | null>{
        try{
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.get(this.links.getUpvestAccountInfo(),this.headers);
            let account:UpvestAccount = json.data;
            this.setAccount(account);
            return account;
        }
        catch(err){
            return null;
        }
    }
    public static async getCurrentAccounValuation(upvestAccountId:string):Promise<UpvestValuationItem>{
        try{
            
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.get(this.links.getCurrentUpvestAccountValuation(upvestAccountId),this.headers);
            let response:UpvestValuationItem = json.data;
            return response;
        }
        catch(err){
            throw err;
        }
    }
    public static async getAccountValueHistory(request:UpvestHistoryValueRequest):Promise<Array<UpvestValuationItem>>{
        try{
            const endDate = formatDate(new Date());
            let startDate = '';
            const caculatedDate = moment();
            if(request.period == PricePeriods.week){
                caculatedDate.subtract(1,'week')
            }
            if(request.period == PricePeriods.month){
                caculatedDate.subtract(1,'month')
            }
            if(request.period == PricePeriods.year){
                caculatedDate.subtract(1,'year')
            }
            startDate = formatDate(caculatedDate.toDate());
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.get(this.links.getAccountValuationHistory(request.upvestAccountId,startDate,endDate,request.instrumentId),this.headers);
            let response:Array<UpvestValuationItem> = json.data;
            return response;
        }
        catch(err){
            throw err;
        }
    }
    public static async getAccountPositions(upvestAccountId:string):Promise<Array<UpvestPosition>>{
        try{
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.get(this.links.getUpvestAccountPositions(upvestAccountId),this.headers);
            let response:Array<UpvestPosition> = json.data;
            return response;
        }
        catch(err){
            throw err;
        }
    }
    public static async getUpvestSavingsPlans(upvestAccountId:string):Promise<Array<UpvestSavingPlan>>{
        try{
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.get(this.links.getUpvestAccountSavingsPlan(upvestAccountId),this.headers);
            let response:Array<UpvestSavingPlan> = json.data;
            return response;
        }
        catch(err){
            throw err;
        }
    }
    public static async getConditions(lang:string):Promise<Array<InstrumentCondition>>
    {
        try{
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.get(this.links.getUpvestConditions(lang),this.headers);
            let response:Array<InstrumentCondition> = json.data;
            return response;
        }
        catch(err){
            throw err;
        }
    }
    public static async deleteSavingsPlan(savingsPalnId:string):Promise<Boolean>{
        try{
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            await this.requester.delete(this.links.deleteSavingsPlanLink(savingsPalnId),this.headers);
            return true;
        }
        catch(err){
            throw err;
        }
    }
}